import { useRef } from 'react';

import { useNativeDropZone } from './useNativeDropZone';
import { TreeDragDropHandlers } from './useTreeDragDrop';

const TABLE_BASE_INDENT = 24;
const TABLE_DEPTH_INDENT = 16;

interface UseTreeRowParams {
  depth: number;
  drag: TreeDragDropHandlers;
  index: number;
  isReordering: boolean;
  type: string;
}

/**
 * Shared setup for tree-based row components.
 * Provides a row ref, indent calculation, and native drop zone registration.
 */
export const useTreeRow = ({ depth, drag, index, isReordering, type }: UseTreeRowParams) => {
  const rowRef = useRef<HTMLTableRowElement | null>(null);
  const indentPx = depth * TABLE_DEPTH_INDENT + TABLE_BASE_INDENT;

  useNativeDropZone({
    rowRef,
    onDragOver: drag.onDragOver,
    onDragLeave: drag.onDragLeave,
    onDrop: drag.onDrop,
    isReorderingMode: isReordering,
    index,
    type
  });

  return { rowRef, indentPx };
};
